// Angular
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
// RxJS
import { Observable, throwError  } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
// import { debug } from 'util';

/**
 * More information there => https://medium.com/@MetonymyQT/angular-http-interceptors-what-are-they-and-how-to-use-them-52e060321088
 */
@Injectable()
export class InterceptService implements HttpInterceptor {
	// intercept request and add token
	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {

		return next.handle(request).pipe(
			tap(
				event => {
					 if (event instanceof HttpResponse) {
					}
				}
			),
			catchError(
				(error: HttpErrorResponse): Observable<any> => {
					// other errors we don't know how to handle and throw them further.
					return throwError(error);
				},
			)
		);
	}
}
